import { CanvasRenderingCtx } from '../rendering';
import { PhotoEditorAnnotationCanvasRenderer } from './photo-editor.decorator';
import { CircleAnnotation } from './annotation';

export class CirclePenRenderer implements PhotoEditorAnnotationCanvasRenderer<CircleAnnotation> {
  constructor(
    private readonly ctx: CanvasRenderingContext2D,
    public annotation: CircleAnnotation,
  ) {}

  draw(renderingCtx: CanvasRenderingCtx): void {
    this.ctx.save();

    this.ctx.lineWidth = 2;
    this.ctx.strokeStyle = this.annotation.color;

    this.ctx.beginPath();
    this.ctx.ellipse(this.annotation.x, this.annotation.y, this.annotation.radX, this.annotation.radY, 0, 0, 2 * Math.PI);
    this.ctx.stroke();
    this.ctx.closePath();

    this.ctx.restore();
  }
}
